module.exports = __webpack_public_path__ + "assets/img/d5a2-bn.svg";